/*eslint-disable*/
import api from '../'

class visionFieldApi {
    static getWords (params) {
        return api.axios.get('/vision-field/words', { params }).then(response => response.data);
    }
}

export default visionFieldApi;
